// @flow
import React, { useContext } from 'react';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';

import { ImmersiveSlideShowItem } from './item/ImmersiveSlideShowItem.jsx';
import { ImmersiveSlideShowLarge } from './large/ImmersiveSlideShowLarge.jsx';
import { ImmersiveSlideShowNarrow } from './narrow/ImmersiveSlideShowNarrow.jsx';

type Props = {
  className?: string,
  hasInsetBorder?: boolean,
  insetBorderOffset?: number,
  immersiveSize?: ImmersiveSizeProps,
  media: Array<string>,
  nextLabel?: string,
  previousLabel?: string,
};

export function ImmersiveSlideShow(props: Props) {
  const { immersiveSize = 'large', media = [], nextLabel, previousLabel, ...rest } = props;

  const { isDesktop } = useContext(ResponsiveContext);

  if (!media.length) return null;

  const items = media.map(src => (
    <ImmersiveSlideShowItem {...rest} immersiveSize={immersiveSize} key={src} src={src} />
  ));

  return isDesktop ? (
    <ImmersiveSlideShowLarge
      items={items}
      immersiveSize={immersiveSize}
      nextLabel={nextLabel}
      previousLabel={previousLabel}
    />
  ) : (
    <ImmersiveSlideShowNarrow items={items} nextLabel={nextLabel} previousLabel={previousLabel} />
  );
}
